export const firebaseConfig = {
  apiKey: 'AIzaSyCV-mwKVrDM0OJ2aCzXtFTOncgGWEgomOw',
  authDomain: 'js-team-project-6fcff.firebaseapp.com',
  projectId: 'js-team-project-6fcff',
  storageBucket: 'js-team-project-6fcff.appspot.com',
  baseUrl:
    'https://js-team-project-6fcff-default-rtdb.europe-west1.firebasedatabase.app',
  messagingSenderId: '338700524945',
  appId: '1:338700524945:web:6c676d5af2a340eaa54e30',
};
